import { useMutation } from "urql";

import { UpdateClikCompanyDataDocument } from "../../../graphql/generated.ts";

export function useUpdateClikCompanyData() {
  return useMutation(UpdateClikCompanyDataDocument);
}
